import React, { useState, useEffect, useCallback, useRef } from 'react';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import { useLocation } from 'react-router-dom';

export default function EventDetail() {
  const location = useLocation();
  const event = location.state || {};

  const slides = Array.isArray(event.EvtImages) ? event.EvtImages : [];

  const [activeSlide, setActiveSlide] = useState(() =>
    Math.floor(Math.random() * slides.length)
  );

  const intervalRef = useRef(null);

  const changeSlides = useCallback(() => {
    setActiveSlide((prevSlide) => (prevSlide + 1) % slides.length);
  }, [slides.length]);

  useEffect(() => {
    intervalRef.current = setInterval(changeSlides, 4000);
    return () => clearInterval(intervalRef.current);
  }, [changeSlides]);

  const handleControlClick = (index) => {
    setActiveSlide(index);
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(changeSlides, 4000);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div className="event-detail-container">
      {/* Image Slider */}
      <div className="slider-container position-relative w-100 overflow-hidden" style={{ height: 'fit-content' }}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === activeSlide ? 'active' : ''}`}
            style={{
              backgroundImage: `url(${slide})`,
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: index === activeSlide ? 1 : 0,
              transition: 'opacity 0.5s ease-in-out',
            }}
            role="img"
            aria-label={`Slide ${index + 1}`}
          />
        ))}

        {/* Controls */}
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: 'absolute',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10,
            gap: '10px',
          }}
        >
          {slides.map((_, index) => (
            <div
              key={index}
              className={`control ${index === activeSlide ? 'active' : ''}`}
              onClick={() => handleControlClick(index)}
              style={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: index === activeSlide ? '#DC143C' : '#ccc',
                cursor: 'pointer',
                transition: 'background-color 0.3s',
              }}
            />
          ))}
        </div>
      </div>

      {/* Event Details */}
      <div className="container mt-5">
        <div className="row gy-4">
          {/* Left Panel */}
          <div className="col-lg-5 col-md-6 col-sm-12">
            <div className="mb-3">
              <h4 className="text-center text-secondary">Event Detail</h4>
              <h2 className="text-center fw-bold text-danger">{event.EvtTitle}</h2>
            </div>
            <p><strong>From Date:</strong> {event.EvtFromDate} </p>
            <p><strong>To Date:</strong> {event.EvtToDate }</p>
            <p><strong>Description:</strong> {event.EvtDesc || "No description provided."}</p>
          </div>

          {/* Right Panel */}
          <div className="col-lg-7 col-md-6 col-sm-12">
            <div className="card h-100 shadow-sm border-0">
              <img
                src={slides[0]}
                alt="Event Banner"
                loading="lazy"
                className="img-fluid rounded"
                style={{ maxHeight: 400, objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>

        {/* Gallery */}
        {slides.length > 1 && (
          <div className="container mt-5">
            <h5 className="text-secondary mb-3">More Photos</h5>
            <div className="row g-3">
              {slides.slice(1, 5).map((img, index) => (
                <div key={index} className="col-6 col-md-3">
                  <img
                    src={img}
                    loading="lazy"
                    alt={`Gallery ${index + 1}`}
                    className="img-fluid rounded shadow-sm"
                    style={{ objectFit: "cover", height: "150px", width: "100%" }}
                  />
                </div>
              ))}
            </div>
          </div>
        )} 
        <br /><br /><br /><br />
      </div>

      {/* Scroll to Top */}
      <div
        className="scroll-to-top-button position-fixed bottom-0 end-0 m-4 rounded-circle d-flex align-items-center justify-content-center"
        onClick={scrollToTop}
        style={{
          width: 45,
          height: 45,
          backgroundColor: "#DC143C",
          color: "#fff",
          cursor: "pointer",
          zIndex: 1000,
        }}
        aria-label="Scroll to Top"
      >
        <IoArrowUpCircleOutline size={24} />
      </div>
    </div>
  );
}
